// @ts-ignore
import type {SlAlert} from '../../../../../../vendor/plugins/clxFrontendCms/public/js/shoelace/shoelace';

export type Severity = 'info' | 'success' | 'warning' | 'danger';
export default class Toast {
    private namespace: string;
    constructor(namespace: string) {
        this.namespace = namespace;
    }

    // @ts-ignore
    public async createToast(level: Severity, message: string, duration: Number = undefined): Promise<void> {
        const id = `toast-${Math.round(Math.random() * 1000)}`;
        const toast = `
            <sl-alert class="toast-${this.namespace}" variant="${level}" closable id="${id}" ${duration !== undefined ? 'duration="' + duration + '"' : ''}>
                ${message}
            </sl-alert>
        `;
        document.body.insertAdjacentHTML('beforeend', toast);

        const alert = document.querySelector<SlAlert>(`#${id}`);
        if (!alert) {
            return;
        }
        await alert.toast();
    }

    public removeAllToasts() {
        const toasts = Array.from(document.querySelectorAll<SlAlert>(`sl-alert.toast-${this.namespace}`));

        return Promise.all(toasts.map((toast) => toast.hide()));
    }
}
